<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" color="dark" mode="ios" (click)="dismiss()">
        {{ 'BUTTON.CANCEL' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button strong fill="clear" color="primary" mode="ios" (click)="submit()">
        {{ 'BUTTON.SAVE' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar class="toolbar-wrapper">
    <div class="toolbar-wrapper__inner">
      @if (isLoading) {
        <ion-spinner class="proto-spinner"></ion-spinner>
      } @else {
        <ion-label class="toolbar-meta">
          {{ totalItemsInDatabase }} {{ 'TERM.SEARCH_RESULT' | translate }}
        </ion-label>
      }
    </div>
  </ion-toolbar>
</ion-header>
<ion-content #ListContent
  [ngClass]="{
    'modal-content': true,
    'show-skeleton': isLoading,
    'is-loading': isLoading }">

  <div class="proto-content">
    <ion-radio-group [ngModel]="selectedItemIds[0]">
      <ion-list lines="none">
        @for (item of roles; let i = $index; track item ? item.id : i) {
          <role-preview
            [type]="currentListType"
            [item]="item"
            (openDetail)="onItemClicked($event)">
            @if (!isMultiSelect) {
              <ion-radio class="list-item-checkbox" [value]="item?.id"></ion-radio>
            } @else {
              <ion-checkbox class="list-item-checkbox" [checked]="selectedItemIds.includes(item?.id)"></ion-checkbox>
            }
          </role-preview>
        }
      </ion-list>
    </ion-radio-group>
  </div>
</ion-content>
